import { NodeOf } from "@p0security/shared/graph/types";
import { Drawer } from "antd";
import { startCase } from "lodash";
import { ReactNode, useContext, useMemo } from "react";

import { NodeFlowRenderer } from "../GraphVisualization";

export const NodeDrawer = <G extends object, P>(props: {
  node?: NodeOf<G>;
  onClose: () => void;
  describer: (node: NodeOf<G>) => ReactNode;
  renderer: NodeFlowRenderer<G, P>;
  renderContext: React.Context<P>;
}) => {
  const { describer, node, onClose, renderer, renderContext } = props;

  const renderArgs = useContext(renderContext);

  const drawerTitle = useMemo(
    () =>
      node
        ? startCase(
            String(renderer[node.type].title(node, renderArgs) ?? node.type)
          )
        : undefined,
    [node, renderer, renderArgs]
  );

  return (
    <Drawer
      styles={{
        body: { padding: 0 },
        header: { padding: "10px" },
      }}
      // Poorly documented API that forces inline drawer display
      getContainer={false}
      mask={false}
      onClose={onClose}
      open={!!node}
      placement="right"
      title={drawerTitle}
      width="min(80%, 450px)"
    >
      {!!node ? describer(node) : null}
    </Drawer>
  );
};
